module.exports = __webpack_public_path__ + "img/速卖通.dd54220c.png";